import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled from 'styled-components'

import { decodeHtml } from '@nx/decode-html'
import { Label } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import translate from './CurrentBid.translate.json'

const { text } = getTranslate(translate)

export const CurrentBid = memo(
  ({ currencySymbol, price, isOutbid = false, ...props }: CurrentBidProps) => (
    <StyledCurrentBidLabel $level="M" {...props}>
      {text(isOutbid ? 'currentWinning' : 'current', {
        price: buildPriceString({
          currencySymbol: decodeHtml(currencySymbol),
          lowPrice: price,
        }),
      })}
    </StyledCurrentBidLabel>
  ),
  isEqual
)

export const StyledCurrentBidLabel = styled(Label)`
  /* Empty for override styles */
`

export interface CurrentBidProps {
  currencySymbol: string
  price: number
  isOutbid?: boolean
}
